import { RedoBadge } from "@redotech/arbiter/badge/redo-badge";
import { Flex } from "@redotech/arbiter/flex";

export function PortalMetafieldBadges({
  values,
}: {
  values: string[] | undefined;
}) {
  if (!values?.length) {
    return null;
  }

  return (
    <Flex data-ui="item-metafields" gap="xs" pt="xs" wrap="wrap">
      {values.map((value, index) => (
        <RedoBadge
          color="grayBlue"
          key={`${index}-${value}`}
          size="xs"
          text={value}
          uiSelector="item-metafield"
        />
      ))}
    </Flex>
  );
}
